import { createSelector } from 'reselect';
import {
  overEvery,
  negate,
  some,
  identity,
  rest,
  curryRightN,
} from 'lodash/fp';
import { hasGlobalFeature } from '../index';
import { hasAnyIncompleteAssignments } from './assignments';
import { hasTopics } from './topics';

const hasFeatureDisabled = curryRightN(2, negate(hasGlobalFeature));

/**
 * This selector is used to determine if the "Additional Learning Content"
 * section of the "My Learning Content" page is the only section being
 * displayed. Use this selector inside the AdditionalContents component to
 * make visual changes as needed based on the result of this selector.
 */
export const hasOnlyAdditionalContentsSection = createSelector(
  [
    overEvery([
      hasFeatureDisabled('hide_my_assignments'),
      hasAnyIncompleteAssignments,
    ]),
    hasTopics,
  ],
  rest(negate(some(identity))),
);
